export default "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 25\"><path d=\"m14 17.28-5-5 5-5v10Z\"/></svg>\n"